type ImportFn = () => Promise<unknown>;

const PREFETCH_MAP: Record<string, ImportFn> = {
  '/nos-activites/action-game': () => import('../pages/ActionGame'),
  '/entreprises/team-building': () => import('../pages/TeamBuilding'),
  '/entreprises/privatisation': () => import('../pages/Privatisation'),
  '/entreprises/seminaire': () => import('../pages/Seminaire'),
  '/infos-pratiques': () => import('../pages/InfosPratiques'),
  '/actualites': () => import('../pages/Actualites'),
  '/contact': () => import('../pages/Contact'),
  '/formules/evg-evjf': () => import('../pages/FormuleEvgEvjf'),
  '/formules/anniversaire-enfant': () => import('../pages/FormuleAnniversaireEnfant'),
  '/mentions-legales': () => import('../pages/LegalPages'),
  '/politique-de-confidentialite': () => import('../pages/LegalPages'),
  '/politique-de-cookies-ue': () => import('../pages/LegalPages'),
};

const prefetched = new Set<string>();

export function prefetchRoute(href: string | null | undefined) {
  if (!href || !href.startsWith('/')) return;
  const path = href.split('?')[0].split('#')[0];
  if (prefetched.has(path)) return;
  const fn = PREFETCH_MAP[path];
  if (!fn) return;
  prefetched.add(path);
  fn().catch(() => prefetched.delete(path));
}
